
/// <reference path="TaxRegimeTypeCell.ts" />

class TaxRegimeTypeViewController extends MUIViewController
{
    static newInstance() : TaxRegimeTypeViewController
    {
        let vc = new TaxRegimeTypeViewController("tax-regime-type-view");
        vc.initWithResource("layout/setup/TaxRegimeTypeView.html");
        return vc;
    }

    private saveButton:MUIButton = null;
    private addButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.managedObjectContext.save();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addButtonDidPress);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.tableView.reloadData();
    }

    numberOfSections(tableview){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview, section){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("TaxRegimeTypeCell") as TaxRegimeTypeCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as TaxRegimeType;
        cell.item = item;
        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) : any {
        return MUITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath);
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.managedObjectContext.deleteObject(item);
            ad.managedObjectContext.save();
        }
    }

    private nextValue():number {
        let max = -1;
        let count = this.fetchedResultsController.sections[0]?.numberOfObjects() ?? 0;
        for (let i = 0; i < count; i++) {
            let item = this.fetchedResultsController.objectAtIndexPath(MIOIndexPath.indexForRowInSection(i, 0)) as TaxRegimeType;
            if (item.value != null && item.value > max) max = item.value;
        }
        return max + 1;
    }

    private addButtonDidPress(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_TAX_REGIME_TYPE", "NEW TAX REGIME TYPE"), MIOLocalizeString("CHOOSE_A_TITLE", "CHOOSE A TITLE"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
           textField.setPlaceholderText(MIOLocalizeString("TITLE", "TITLE"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let d = MIOEntityDescription.insertNewObjectForEntityForName("TaxRegimeType", ad.managedObjectContext) as TaxRegimeType;
            d.title = name;
            d.value = this.nextValue();

            ad.managedObjectContext.save();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    // MARK: - Fetched results controller

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (this._fetchedResultsController != null) {
            this._fetchedResultsController.delegate = null;
        }
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;
        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("value", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("TaxRegimeType", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller){
        this.tableView.reloadData();
    }
}
